// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__3jp0a","error":"Notification_error__iMkn4","success":"Notification_success__WxlOo"};